import WebIM from '@/utils/webIM'
export default {
  initChatData(state, payload) {
    let _tempID = []
    state.conversationList = []
    payload.forEach(item => {
      // 非本人 && 去重
      if(item.easemobAccount.toUpperCase() !== item.fromImUser.toUpperCase() && _tempID.indexOf(item.easemobAccount.toUpperCase()) === -1) {
        state.allChatData[item.easemobAccount.toUpperCase()] = []
        state.canLoadMore[item.easemobAccount.toUpperCase()] = false
        _tempID.push(item.easemobAccount.toUpperCase())
        state.conversationList.push(item)
      }
    })
  },

  clearAllChatData(state) {
    state.allChatData = {}
    state.chatMsgList = []
  },

  setLoadMoreArr(state, payload) {
    state.canLoadMore[payload.imAccount] = payload.value
  },

  // set localStorage msg to store if exist
  // deperacated
  // syncChatMsg(state, payload) {
  //   state.allChatData = payload
  //   this.commit('setUserList')
  // },

  fillChatMsg(state, payload) {
    state.allChatData[payload.imAccount] = payload.messages
  },

  syncUserList(state) {
    state.userList = state.conversationList
    this.commit('setUserList')
  },

  setUserList(state) {
    Object.keys(state.allChatData).forEach(item => {
      const amount = state.allChatData[item].length
      // Delete the user which had empty chat record in returend API data
      if(amount === 0) {
        const index = state.userList.findIndex((_item) => {
          return _item.easemobAccount.toUpperCase() === item.toUpperCase()
        })
        state.userList.splice(index, 1)
      }
      if (amount > 0) {
        let lastMsgTime = state.allChatData[item][amount - 1].time
        state.userList = state.userList.map(user => {
          if (user.easemobAccount.toUpperCase() === item) {
            user.lastMsgTime = lastMsgTime
          }
          return user
        })
      }
    })
    this.commit('sortUserList')
  },

  sortUserList(state) {
    state.userList = state.userList.sort((a, b) => {
      return b.lastMsgTime - a.lastMsgTime
    })
  },

  // fetch chat history, load more
  updateChatList(state, payload) {
    state.needScrollToBottom = payload.needScrollToBottom
    state.chatMsgList = payload.res.concat(state.chatMsgList)
    state.allChatData[state.receivingUser] = state.chatMsgList
  },

  setChatList(state, payload) {
    state.needScrollToBottom = true
    if (!state.chatMsgList) {
      state.chatMsgList = []
    }

    let receiverID = payload.bySelf ? state.receivingUser : payload.chatId
    receiverID = receiverID.toUpperCase()

    // get account from PC otherwise from App
    let easemobAccount = payload.ext.easemobAccount || payload.chatId

    // receiving new msg from other users, include offline msg
    if (easemobAccount.toUpperCase() !== state.receivingUser) {
      if (state.allChatData[receiverID]) {
        state.allChatData[receiverID].push(payload)
      } else {
        // new contact, not exist before
        state.allChatData[receiverID] = [payload]

        state.userList.push(payload.ext)
        // save new contact to server
        this.dispatch('saveContact', payload.ext)
        // console.log('receive msg', state.userList, payload)
      }
    } else {
      // msg from current user chat dialog
      payload.status = 'read'
      state.chatMsgList.push(payload)
      state.allChatData[receiverID] = state.chatMsgList

      if (!state.userList.find(item => item.easemobAccount === receiverID)) {
        state.userList.push(payload.ext)
        // save new contact to server
        this.dispatch('saveContact', payload.ext)
        // console.log('sending msg', state.userList)
      }
    }

    if(state.user.isLogin) {
      this.commit('setUserList')
    }
  },

  setChatConnecting(state, payload) {
    state.isChatConnecting = payload
  },

  setChatRole(state, payload) {
    state.imRole = payload
  },
  
  setSendingUser(state, payload) {
    state.sendingUser = payload
  },

  setReceivingUser(state, payload) {
    state.receivingUser = payload
    if (payload) {
      state.chatMsgList = state.allChatData[state.receivingUser]

      if (state.chatMsgList) {
        // set message status to read
        state.chatMsgList.map(item => {
          item.status = 'read'
          // get audio url from localstorage(chat history) then download replaced to blob:url
          if (item.type === 'audio' && item.audioURL) {
            let options = { url: item.audioURL }

            options.onFileDownloadComplete = function(response) {
              //音频下载成功，需要将response转换成blob，使用objectURL作为audio标签的src即可播放。
              item.msg = WebIM.utils.parseDownloadResponse.call(WebIM.conn, response)
            }

            options.onFileDownloadError = function() {
              //音频下载失败
              // console.log('下载失败')
            }

            //通知服务器将音频转为mp3
            options.headers = {
              Accept: 'audio/mp3'
            }

            WebIM.utils.download.call(WebIM.conn, options)
          }
        })
        state.allChatData[state.receivingUser] = state.chatMsgList

        // localStorage.setItem(`allChatData__${state.sendingUser}`, JSON.stringify(state.allChatData))
      }
    }
  },

  setReceiver(state, payload) {
    if (payload) {
      payload.easemobAccount = payload.easemobAccount.toUpperCase()
      state.receiver = payload
      this.commit('setReceivingUser', payload.easemobAccount)
    } else {
      state.receiver = {}
      this.commit('setReceivingUser', '')
    }
  },

  toogleChatDialog(state) {
    state.chatDialogVisible = !state.chatDialogVisible
  },

  toogleExhibitorDialog(state) {
    state.exhibitorDialogVisible = !state.exhibitorDialogVisible
  },

  toogleMediaChat(state) {
    state.emediaChatVisible = !state.emediaChatVisible
  },

  setNewMessageStatus(state, payload) {
    state.newMessageComing = payload
  },

  setNewMailStatus(state, payload) {
    state.newMailComing = payload
  },

  setChatEmployeeList(state, payload) {
    state.chatEmployeeList = payload
  },

  setStreamType(state, payload) {
    state.streamType = payload
  },

  setRinging(state, payload) {
    state.onRinging = payload
  },

  setContact(state, payload) {
    state.contact = payload
  },

  makeCall(state, name) {
    state.isCallerWaiting = true
    state.contact = name
  },

  setOnlineServices(state, payload) {
    state.onlineServices = payload
  },

  setTouristService(state, payload) {
    state.touristService = payload
  },
  
  setOnlineServiceTel(state, payload) {
    state.onlineServiceTel = payload
  },

  setOnlineStatus(state, payload) {
    state.onLine = payload
  },

  // 员工管理
  setEmployeeDetail(state, payload) {
    if (payload.id) {
      payload.emailmobile = payload.email || payload.mobile
    }
    state.employeeDetail = payload
  }
}
